import React, { useEffect, useState } from 'react';
import './ClaimSuccess.css';

const ClaimSuccess = () => {
  const [walletAddress, setWalletAddress] = useState('');
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // ✅ If wallet was stored earlier, allow permanent access
    const storedWallet = localStorage.getItem('approved_wallet');

    if (storedWallet) {
      setWalletAddress(storedWallet);
      setIsConnected(true);
    } else {
      // ❌ No wallet stored = not approved, redirect after delay
      setTimeout(() => {
        window.location.replace('/');
      }, 1500);
    }
  }, []);

  const handleDisconnect = () => {
    localStorage.removeItem('approved_wallet');
    setWalletAddress('');
    setIsConnected(false);
  };

  const handleConnect = async () => {
    try {
      if (window.ethereum) {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const address = accounts[0];
        setWalletAddress(address);
        setIsConnected(true);
        localStorage.setItem('approved_wallet', address); // ✅ Approve permanently
      } else {
        alert("MetaMask or compatible wallet not found.");
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  return (
    <div className="claim-success-container">
      <div className="success-card">
        <h1>🤖 VORTREX Bot Activated!</h1>
        <h2>You're now live on automated trading mode 🚀</h2>
        <p>Our AI is scanning markets and preparing trades just for you.</p>
        <p>Stay connected and track your progress anytime.</p>

        {/* ✅ Show Wallet Address if Connected */}
        {isConnected && (
          <p><strong>Connected Wallet:</strong><br />{walletAddress}</p>
        )}

        {/* ✅ Toggle Button UI */}
        <div className="button-group">
          {isConnected ? (
            <button className="btn" onClick={handleDisconnect}>🔌 Disconnect Bot</button>
          ) : (
            <button className="btn" onClick={handleConnect}>🔗 Connect Wallet</button>
          )}
          <a href="/dashboard" className="btn">📊 Go to Dashboard</a>
          <a href="https://t.me/vortrexportal" className="btn">📲 Join Telegram</a>
        </div>
      </div>
    </div>
  );
};

export default ClaimSuccess;
